import { UserProfile } from "@auth0/nextjs-auth0";
import React from "react";
import styled from "styled-components";
import { pxToRem } from "@input-output-hk/px-to-rem";
import { Avatar } from "../avatar/Avatar";
import { AvatarPlaceholder } from "../avatar/AvatarPlaceholder";
import Button from "../buttons/Button";
import TextArea from "../textarea/TextArea";
import { forPhoneOnly, not } from "../../tokens/media-queries";

const CommentInputElement = styled.div`
  display: flex;
  align-items: flex-start;
  @media ${forPhoneOnly} {
    > :first-child {
      display: none !important;
    }
    [data-comment-input] {
      padding-right: ${pxToRem(100)};
    }
  }
  > :first-child {
    flex-shrink: 0;
  }
  @media ${not(forPhoneOnly)} {
    > * + * {
      margin-left: var(--spacing-large);
    }
    [data-comment-input] {
      padding-right: ${pxToRem(170)};
    }
  }
`;

const InputWrapper = styled.span`
  width: 100%;
  position: relative;
`;

const CommentButton = styled(Button)`
  position: absolute;
  right: ${pxToRem(6)};
  top: ${pxToRem(6)};
  border-width: ${pxToRem(1)};
  min-width: auto !important;
  span {
    padding: var(--spacing-small);
  }
  @media ${forPhoneOnly} {
    span {
      display: none;
    }
    top: unset;
    bottom: ${pxToRem(15)};
  }
`;

const UserAvatar = styled(Avatar)`
  @media ${forPhoneOnly} {
    display: none !important;
  }
`;

const DummyAvatar = styled(AvatarPlaceholder)`
  @media ${forPhoneOnly} {
    display: none !important;
  }
`;
type Props = React.ComponentPropsWithoutRef<typeof TextArea> & {
  user?: UserProfile;
};
const CommentInput: React.FC<Props> = ({ user, ...rest }) => {
  const isValue = rest?.value?.length > 0;
  const placeholder = user ? "Write a comment" : "Login to join the discussion";
  return (
    <CommentInputElement>
      {user?.picture ? (
        <UserAvatar level="0" src={user.picture} alt={user.name || "profile"} />
      ) : (
        <DummyAvatar data-comment-avatar-placeholder level="0" />
      )}
      <InputWrapper>
        <TextArea
          data-comment-input
          autogrow
          placeholder={placeholder}
          {...rest}
        />
        {isValue && (
          <CommentButton
            data-comment-submit
            appearance="secondary"
            onClick={rest?.click?.onClick}
          >
            Submit<span>comment</span>
          </CommentButton>
        )}
      </InputWrapper>
    </CommentInputElement>
  );
};

export default CommentInput;
